
<div style="overflow:hidden;">
    <unity [dataContext]="libraryNavigationService" [width]="'calc(100% - 245px)'" [height]="'calc(100% - 38px)'" [config]="unityConfig" [showFullscreenButton]="true" />
</div>
